import React from 'react';

import { Modal } from 'app/design-system/components/Modal';

import { StepContext, useStepContextValue } from '../../contexts/stepContext';
import { UserContext, useUserContextValue } from '../../contexts/userContext';
import { ModalFooter } from '../MoadlFooter';
import { ModalHeader } from '../ModalHeader';
import { StepContent } from '../StepContent';

import styles from './ModalContent.module.scss';

export const ModalContent = () => {
  const stepContextValue = useStepContextValue();
  const userContextValue = useUserContextValue();

  return (
    <StepContext.Provider value={stepContextValue}>
      <UserContext.Provider value={userContextValue}>
        <ModalHeader />
        <Modal.Body
          className={styles.modalBody}
          data-test="Modal-restorePassword-body">
          <StepContent />
          <ModalFooter />
        </Modal.Body>
      </UserContext.Provider>
    </StepContext.Provider>
  );
};
